import { SignUp } from '@clerk/clerk-react'
import './V2Auth.css'

/**
 * V2 signup — delegates to Clerk's <SignUp /> component.
 *
 * Free-plan defaults (1 seat / 5 quotes per month) are applied by the
 * backend when the Clerk webhook fires `organization.created`. Users
 * who want more seats/quotes contact sales — there is no self-serve
 * upgrade flow (sales grants via the platform admin UI).
 */
const clerkAppearance = {
  variables: {
    colorPrimary: '#23201C',
    colorText: '#23201C',
    colorTextSecondary: '#8F432F',
    colorBackground: '#FFFFFF',
    colorInputBackground: '#F3F2ED',
    colorInputText: '#23201C',
    fontFamily: 'Inter, system-ui, sans-serif',
    borderRadius: '6px'
  },
  elements: {
    card: { boxShadow: '0 2px 12px rgba(35,32,28,0.06)' },
    headerTitle: { fontFamily: 'Optima, Georgia, serif', fontWeight: 400 },
    formButtonPrimary: {
      background: '#23201C',
      '&:hover': { background: '#3a3530' }
    }
  }
}

export default function V2SignupPage() {
  return (
    <div className="v2-auth-page">
      <SignUp
        routing="hash"
        signInUrl="/login"
        appearance={clerkAppearance}
      />
    </div>
  )
}
